import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';

import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class WithAuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    if(!this.authService.isAuthenticated()) {
      localStorage.setItem('REDIRECT_URL', state.url);
      this.router.navigate(['login']);
      return false;
    } else {
      return this.authService.getUserDetails().then(userDetails => {
        if(userDetails.type == 'user') {
          if(this.mustChangePassword(userDetails, state.url)) return false;
          if(userDetails.user.privacy_policy == 0) {
            // Redirect to Verdentum Privacy Policy Page
            this.router.navigate(['intro/verdentum_privacy']);
          } else if(userDetails.user.org_privacy_policy != 1) {
            // Redirect to Organization Privacy Policy Page
            this.router.navigate(['intro/org_privacy']);
          }
        }
        return true;
      });
    }
    return true;
  }

  /** Moving between pages inside /user does not re-run canActivate — this keeps the
   *  "set your own password" rule on every page change too (BATCH 108). */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    if(!this.authService.isAuthenticated()) return true;   // canActivate handles the login redirect
    return this.authService.getUserDetails().then(userDetails => {
      if(userDetails && userDetails.type == 'user' && this.mustChangePassword(userDetails, state.url)) return false;
      return true;
    });
  }

  /**
   * TECH-001 (BATCH 108): the administrator ticked "must set own password" on a reset →
   * the profile page (its Change Password dialog opens by itself) is the only page allowed.
   */
  private mustChangePassword(userDetails: any, url: string): boolean {
    if(Number(userDetails?.user?.must_change_pass) !== 1) return false;
    if((url || '').startsWith('/user/profile')) return false;
    this.router.navigate(['/user/profile']);
    return true;
  }
}
